import { AvatarItem } from '@atlaskit/avatar';
import React, { ReactNode } from 'react';
import styled from '@emotion/styled';
import { gridSize } from '../theme/constants';
import { CustomAvatarItemProps } from '@atlaskit/avatar/AvatarItem';

const AvatarCellWrapper = styled.div`
  & {
  display: flex;
  align-items: center;
  cursor: inherit;
  // padding: ${gridSize()}px 0px;
   padding: 0.25rem 0rem;
  }
  &,
  &:hover,
  &:active,
  &:focus {
    margin: 0;
    border: none;
  }
  > * {
    cursor: inherit;
  }
`;

export const AvatarCellTextWrapper = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  // padding-left: ${gridSize()}px;
`;

export type AvatarCellProps = {
  avatar: ReactNode;
  primaryText?: ReactNode;
  secondaryText?: ReactNode;
};

export const AvatarCell = (props: AvatarCellProps) => (
  <AvatarCellTextWrapper>
    <AvatarItem
      backgroundColor="transparent"
      {...props}
    >{(itemProps: CustomAvatarItemProps)=>
      <AvatarCellWrapper>{itemProps.children}</AvatarCellWrapper>}
    </AvatarItem>
  </AvatarCellTextWrapper>
);

export default AvatarCell;

// import { css, jsx } from '@emotion/react';
// import Avatar from '../avatar';
// import { colors } from '../theme';

// <div css={css`display: flex; flex-display:column;`}>
//   <Avatar size="medium" src={'http://logo.accountingbox.nl/?website=rabobank.nl'} />
//   <div>{bankAccountNumber}
//     <div
//       css={css`
//                   color: ${colors.subtleText()};
//                 `}
//     >
//       {bankType}
//     </div></div>
// </div>
